import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-field-select',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyModule
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    template: `
    <div [id]="field.key"
        [class]="'form-group schema-form-select has-feedback ' + (props['htmlClass'] || '')"
        [class.has-success]="(formControl.dirty || formControl.touched) && formControl.status === 'VALID'"
        [class.has-error]="(formControl.dirty || formControl.touched) && formControl.status === 'INVALID'">
            <label *ngIf="props['title']"
              [class]="'control-label ' + props['labelHtmlClass'] || ''"
              [innerHTML]="props.required !== true ? props['title'] + ' (Optional)' : props['title']">
            </label>
            <p *ngIf="props['supportingText']">{{props['supportingText']}}</p>
            <div class="has-feedback">
                <select ngDefaultControl
                    [id]="field.key!.toString()"
                    [name]="field.key"
                    [class]="'form-control ' + props['fieldHtmlClass'] || ''"
                    [formControl]="formControl"
                    [formlyAttributes]="field"
                    [attr.aria-describedby]="'control' + field.key + 'Status'"
                    [attr.readonly]="props['readonly'] ? 'readonly' : null"
                    [attr.required]="props['required']">
                >
                  <!-- <option *ngIf="props.placeholder" [ngValue]="undefined">{{ props.placeholder }}</option> -->
                  <ng-container *ngIf="props.options">
                    <ng-container *ngFor="let opt of props.options">
                      <option *ngIf="!opt.group; else optgroup" [ngValue]="opt.value" [disabled]="opt.disabled">
                        {{ opt.name }}
                      </option>
                      <ng-template #optgroup>
                        <!-- <optgroup [label]="opt.name">
                          <option *ngFor="let child of opt.group" [ngValue]="child.value" [disabled]="child.disabled">
                            {{ child.name }}
                          </option>
                        </optgroup> -->
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </select>
                <i *ngIf="(formControl.dirty || formControl.touched)" class="fa form-control-feedback" [class.fa-times-circle-o]="formControl.status === 'INVALID'" [class.fa-check-circle-o]="formControl.status === 'VALID'"></i>
            </div>
        <div class="help-block" *ngIf="(formControl.dirty || formControl.touched)">
            <formly-validation-message [field]="field"></formly-validation-message>
        </div>
    </div>
  `
})
export class SelectFieldTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
    ngOnInit() {
        if (this.formControl.value) {
            this.formControl.markAsTouched();
        }
    }
}
